const subscriptionActionTypes = {
  // Fetch subscription plans
  FETCH_SUBSCRIPTION_PLANS: "FETCH_SUBSCRIPTION_PLANS",
  FETCH_SUBSCRIPTION_PLANS_SUCCESS: "FETCH_SUBSCRIPTION_PLANS_SUCCESS",
  FETCH_SUBSCRIPTION_PLANS_FAILURE: "FETCH_SUBSCRIPTION_PLANS_FAILURE",
};

export default subscriptionActionTypes;
